'use client'
import { cn } from '@/utilities/ui'
import useClickableCard from '@/utilities/useClickableCard'
import Link from 'next/link'
import type { Post } from '@/payload-types'
import Image from 'next/image'

export type CardPostData = Pick<Post, 'slug' | 'categories' | 'meta' | 'title' | 'heroImage' | 'publishedAt'>

export const BlogCard: React.FC<{
  alignItems?: 'center'
  className?: string
  doc?: CardPostData
  relationTo?: 'posts'
  showCategories?: boolean
  title?: string
  lang: string
}> = (props) => {
  const { card, link } = useClickableCard({})
  const { className, doc, lang, relationTo, showCategories, title: titleFromProps } = props

  const { slug, categories, meta, title, heroImage, publishedAt } = doc || {}
  const { description, image: metaImage } = meta || {}

  const hasCategories = categories && Array.isArray(categories) && categories.length > 0
  const titleToUse = titleFromProps || title
  const href = `/${relationTo}/${slug}`

  const date = publishedAt ? new Date(publishedAt) : null
  const month = date?.toLocaleString(lang, { month: 'short' })
  const day = date?.getDate()

  return (
    <Link
        href={href}
        className={cn(
          'flex flex-col sm:flex-row bg-card text-typography rounded-2xl overflow-hidden shadow hover:shadow-md',
          className
        )}
      >
      {/* Blog Image */}
      <div className="relative w-full sm:w-1/3">
        <Image
          src={heroImage?.sizes?.medium?.url}
          alt={titleToUse || ''}
          fill
          className="w-full h-full object-cover"
        />

        {/* Date Badge */}
        {date && (
          <div className="absolute bottom-4 left-4 bg-card rounded-xl w-[70px] h-[70px] text-center flex flex-col justify-center gap-1">
            <div className="text-sm text-typography capitalize">{month}</div>
            <div className="text-base font-semibold">{day}</div>
          </div>
        )}
      </div>
      {/* Content */}
      <div className="flex flex-col px-8 py-10 sm:w-2/3 justify-center">
        <h2 className="md:text-xl text-base font-semibold mb-6">{title}</h2>
        <p className="text-typography text-sm">{description}</p>
      </div>
    </Link>
  )
}